import { mapGetters } from 'vuex';
// import exciseService from './../../services/exciseEntry';
export default {
  data() {
    return {
      additionalCodes: [],
    };
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    translation: {
      type: String,
      required: false,
    },
    noDataMessage: {
      type: String,
      required: false,
    },
    link: {
      type: Function,
      required: false,
    },
    // linkKey: {
    //   type: String,
    //   required: false,
    // },
    // rowKey: {
    //   type: String,
    //   required: false,
    // },
    buttons: {
      type: Array,
      required: false,
    },
    // expandableKey: {
    //   type: String,
    //   required: false,
    // },
    // expandableRows: {
    //   type: String,
    //   required: false,
    // },
    // group_key_id: {
    //   type: String,
    //   required: true,
    // },
    // additional_key_code: {
    //   type: String,
    //   required: true,
    // },
    // packaging_type_id: {
    //   type: String,
    //   required: true,
    // },
    // basic_id: {
    //   type: String,
    //   required: true,
    // },
    loading: {
      type: Boolean,
      required: false,
    },

    update_list: {
      type: Function,
      required: true,
    },

  },


  computed: {
    ...mapGetters({
      groups: 'allExciseGroups',
      codes: 'allAdditionalCode',
      excisePackagingGroups: 'allExcisePackagingGroups',
      exciseBasicGroups: 'allExciseBasicGroups',
    }),
  },

  watch: {
    //
  },

  methods: {
    html(data) {
      return data;
    },

    rowClicked(row) {
      this.$refs.tableData.toggleRowExpansion(row);
    },

    // save(scope) {
    //   const me = this;
    //   exciseService.update(scope.row.id, scope.row)
    //     .then((data) => {
    //       console.log(data);
    //       this.$message({
    //         message: this.$t('static.exciseEntry.update.success'),
    //         type: 'success',
    //       });
    //       // me.list[scope.$index] = data;
    //       // console.log(scope.$index);
    //       me.update_list(scope.$index, data);
    //     })
    //     .catch((errors) => {
    //       this.$message({
    //         message: errors.message,
    //         type: 'error',
    //       });
    //     });
    // },
    // inArray(needle, haystack) {
    //   if (haystack !== undefined) {
    //     var arr = haystack.split(',');
    //   } else {
    //     var arr = new Array();
    //   }

    //   for (const i in arr) {
    //     if (arr[i] == needle) return true;
    //   }
    //   return false;
    // },
  },

  mounted() {
    console.log(this.list);
  },

  components: {
    VPagination: require('./../../components/paginationNew/paginationNew.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/exciseTable/exciseTable.js